import { Badge } from "@/components/ui/badge";
import ResourceManager, { ActiveBadge } from "@/components/admin/ResourceManager";

const fields = [
    { name: "name", label: "Package name", type: "text", required: true },
    { name: "price_display", label: "Price display", type: "text", placeholder: "£499 or Custom Quote", required: true },
    { name: "short_description", label: "Short description", type: "textarea", rows: 2 },
    { name: "features", label: "Features", type: "tags", help: "One feature per line" },
    { name: "best_for", label: "Best for", type: "textarea", rows: 2 },
    { name: "cta_text", label: "CTA text", type: "text", default: "Enquire now" },
    { name: "is_featured", label: "Most popular", type: "switch", toggleLabel: "Highlighted as featured" },
    { name: "order", label: "Sort order", type: "number" },
    { name: "is_active", label: "Active", type: "switch", default: true, toggleLabel: "Visible on site" },
];

const columns = [
    { key: "name", label: "Package" },
    { key: "price_display", label: "Price" },
    {
        key: "is_featured",
        label: "Featured",
        render: (r) =>
            r.is_featured ? (
                <Badge className="bg-slate-950 text-white">Most popular</Badge>
            ) : (
                <span className="text-slate-400 text-xs">—</span>
            ),
    },
    { key: "is_active", label: "Status", render: (r) => <ActiveBadge active={r.is_active} /> },
];

export default function PricingPage() {
    return (
        <ResourceManager
            title="Pricing Packages"
            description="The packages displayed on the public pricing page."
            endpoint="pricing"
            columns={columns}
            fields={fields}
            testidPrefix="pricing"
            searchKeys={["name", "price_display"]}
        />
    );
}
